import { PHOTOGENIX_API, PHOTOGENIX_API_ADMIN_TOKEN } from "../envConfig";

import { apiCall } from "../api";

export const getAllModels = () => {
  return apiCall(`${PHOTOGENIX_API}/api/options-data/ai-models`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${PHOTOGENIX_API_ADMIN_TOKEN}`,
    },
  });
};

export const updateModel = (data) => {
  return apiCall(`${PHOTOGENIX_API}/api/options-data/ai-models`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${PHOTOGENIX_API_ADMIN_TOKEN}`,
    },
    body: JSON.stringify({ data }),
  });
};

export const getAllBgs = () => {
  return apiCall(`${PHOTOGENIX_API}/api/options-data/scenes`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${PHOTOGENIX_API_ADMIN_TOKEN}`,
    },
  });
};
